
import Page from '@root/common/base/Page';
import CustomerNavigation from '@root/modules/customer/components/CustomerNavigation.vue';
import HeaderOnbordading from '@root/modules/customer/components/newsletter/HeaderOnbordading.vue';
import Header from '@root/modules/customer/components/newsletter/Header.vue';
import NewsletterSelector from '@root/modules/customer/components/newsletter/NewsletterSelector.vue';
import getPageAdsSettings from '@root/modules/customer/utils/getPageAdsSettings';

enum PageState {
  FirstPage = 'FirstPage',
  NewsletterSelect = 'NewsletterSelect',
}
export default Page.extend({
  components: {
    CustomerNavigation,
    HeaderOnbordading,
    NewsletterSelector,
    Header,
  },
  data() {
    return {
      activePage: PageState.FirstPage,
    };
  },
  computed: {
    customerToken(): string {
      return this.$store.state.piano.token;
    },
    customerHasAccess() {
      return this.$store.state.piano.access.channelAccess;
    },
  },
  methods: {
    setActivePage(activePage: PageState) {
      this.activePage = activePage;
    },
  },
  async created() {
    this.setPageAdsSettings(getPageAdsSettings({ $channelConfig: this.$channelConfig }));
  },
  mounted() {
    if (!window?.location?.hash?.includes('#newsletter-select')) {
      this.setActivePage(PageState.FirstPage);
    } else {
      this.setActivePage(PageState.NewsletterSelect);
    }
  },
});
